import {
  Autocomplete,
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  Grid,
  TextField,
} from "../../../../components";

const AddInfoBoletoDialog = ({
  open,
  setOpen,
  enderecos,
  convenios,
  boleto,
  setBoleto,
  gerarBoleto,
  setLoading,
}) => {
  const handleCloseDialog = () => {
    setBoleto(null);
    setOpen(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    const { cliente, contaBancaria, enderecoSelecionado, convenioSelecionado } =
      boleto;
    await gerarBoleto(
      cliente,
      contaBancaria,
      enderecoSelecionado,
      convenioSelecionado,
    );
    setLoading(false);
    handleCloseDialog();
  };

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      disableClickEventBubbling
      fullWidth
      maxWidth="xs"
    >
      <Card>
        <CardHeader title="Emissão de Boleto" />
        <CardContent>
          <Grid container spacing={2}>
            {enderecos.length > 1 && (
              <Grid item xs={12}>
                <Autocomplete
                  id="enderecoId"
                  name="enderecoId"
                  options={enderecos}
                  noOptionsText="Sem opções"
                  autoHighlight
                  getOptionLabel={(option) =>
                    option?.id ? `${option.logradouro}, ${option.numero}` : ""
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      margin="normal"
                      label="Endereço de Envio"
                      variant="outlined"
                    />
                  )}
                  onChange={(e, value) =>
                    setBoleto((prev) => ({
                      ...prev,
                      enderecoSelecionado: value,
                    }))
                  }
                  value={boleto?.enderecoSelecionado}
                  disableClearable
                />
              </Grid>
            )}
            {convenios.length > 1 && (
              <Grid item xs={12}>
                <Autocomplete
                  id="convenioId"
                  name="convenioId"
                  options={convenios}
                  noOptionsText="Sem opções"
                  autoHighlight
                  getOptionLabel={(option) =>
                    option?.numero
                      ? `${option.numero} - ${option.descricao}`
                      : ""
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      margin="normal"
                      label="Convênio Bancário"
                      variant="outlined"
                    />
                  )}
                  onChange={(e, value) =>
                    setBoleto((prev) => ({
                      ...prev,
                      convenioSelecionado: value,
                    }))
                  }
                  value={boleto?.convenioSelecionado}
                  disableClearable
                />
              </Grid>
            )}
          </Grid>
        </CardContent>
      </Card>
      <DialogActions>
        <Button variant="contained" onClick={handleCloseDialog}>
          Fechar
        </Button>
        <Button variant="contained" color="success" onClick={handleSubmit}>
          <i
            className="ph-fill ph-plus-circle"
            style={{ fontSize: 22, marginRight: 10, color: "white" }}
          ></i>
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddInfoBoletoDialog;
